<template>
  <div class="aside">
    <el-menu :default-active="asideIndex" class="el-menu-vertical">
      <el-menu-item @click="clickMenu(item)" v-for="item in asideData" :key="item.name" :index="`${item.name}`">
        <i :class="`${item.icon}`"></i>
        <span slot="title">{{ item.label }}</span>
      </el-menu-item>
    </el-menu>
  </div>
</template>

<script>

export default {
  name: 'MyAside',
  props: ['asideIndex', 'asideData', 'asideClick'],

  methods: {
    clickMenu(item) {
      this.asideClick(item)
    },
  }
}
</script>

<style lang="less" scoped>

.aside {
  width: 200px;
  box-sizing: border-box;
  padding: 16px 12px;

  background: #fff;
  border-right: 1px solid #edf0f5;
  height: calc(100vh - 64px);

  .el-menu-vertical {
    border-right: none;

    /deep/ .el-menu-item {
      height: 44px;
      line-height: 44px;
      margin-bottom: 4px;
      padding-left: 18px !important;
      border-radius: 8px;
      font-size: 14px;
      color: #4b5563;
      transition: all 0.2s ease;

      i {
        color: #9ca3af;
        margin-right: 8px;
        transition: color 0.2s ease;
      }

      &:hover {
        background-color: #f5f8ff;
        color: #2563eb;

        i {
          color: #2563eb;
        }
      }

      &.is-active {
        background: linear-gradient(90deg, rgba(37, 99, 235, 0.1), rgba(79, 70, 229, 0.08));
        color: #2563eb;
        font-weight: 600;
        position: relative;

        i {
          color: #2563eb;
        }

        &::before {
          content: "";
          position: absolute;
          left: 0;
          top: 10px;
          bottom: 10px;
          width: 3px;
          border-radius: 2px;
          background: linear-gradient(180deg, #2563eb, #4f46e5);
        }
      }
    }
  }

  /deep/ .el-submenu__title {
    font-size: 14px;
    border-radius: 8px;
  }
}

.menu-item-lv2 {
  margin-left: 10px;
}

.menu-item-lv3 {
  margin-left: 30px;
}

</style>